import styled from "styled-components";

export interface iTextColorProps {
  color?: string;
  priceColor?: string;
  isAvaliable?: boolean;
}
export const Container = styled.li`
  cursor: pointer;
`;

export const ImageCardContainer = styled.div`
  position: relative;

  > img {
    height: auto;
    max-width: 100%;
  }

  .svg__favorite {
    position: absolute;
    top: 8px;
    right: 8px;
    height: 20px;
    width: 20px;

    @media (min-width: 480px) {
      top: 24px;
      right: 16px;
      height: 48px;
      width: 48px;
    }

    @media (min-width: 768px) {
      top: 12px;
      right: 8px;
      height: 20px;
      width: 20px;
    }
  }
`;
export const NewImageContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 90%;
  top: 8px;

  @media (min-width: 480px) {
    top: 24px;
  }
  @media (min-width: 768px) {
    align-items: initial;
    top: 12px;
  }

  .svg__new {
    display: flex;
    flex-direction: column;
    margin-left: 8px;

    @media (min-width: 480px) {
      margin-left: 16px;
    }

    @media (min-width: 768px) {
      margin-left: 8px;
    }
    > small {
      font-size: 0.625rem;
      line-height: 17px;
      color: #000;
      text-transform: uppercase;

      @media (min-width: 480px) {
        font-size: 0.875rem;
      }

      @media (min-width: 768px) {
        font-size: 0.438rem;
      }
    }
  }
  .div_svg {
    display: flex;
  }
  .svg__zoom {
    cursor: pointer;
    height: 46px;
    width: 46px;
    margin: auto;

    @media (min-width: 380px) {
      width: 36px;
    }
    @media (min-width: 768px) {
      width: 30px;
    }
  }
`;

export const InfoCardContainer = styled.div<iTextColorProps>`
  padding: 10px 10px 16px 10px;
  display: flex;
  flex-direction: column;

  > div {
    display: flex;
    justify-content: flex-start;
    gap: 0.3rem;
    flex-flow: wrap;
    padding-top: 10px;
    margin:0;
  }

  > label {
    text-transform: lowercase;
    color: ${(props) => props.color || props.theme.colors.typography1.pure};
    font-size: 0.75rem;
    line-height: 16px;
    font-weight: 300;

    //diminuindo tamanho da caixa de texto (sem quebra de linha)
    @media (min-width: 390px) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 150px;
      font-size: 0.7rem;
    }

    @media (min-width: 480px) {
      width: 200px;
    }

    @media (min-width: 768px) {
      white-space: normal;
      width: auto;
    }
  }

  > p {
    margin-top: 4px;
    font-size: 0.76rem;
    font-weight: normal;
    color: ${(props) =>
    props.priceColor || props.theme.colors.typography1.medium};

    @media (min-width: 768px) {
      margin: 2px 0 0;
      font-size: 0.7rem;
    }
  }

  > small {
    font-weight: 500;
    font-size: 0.7rem;
    line-height: 17px;
    color: #999999;
    padding-top: 4px;

    @media (min-width: 768px) {
      font-size: 0.6rem;
      line-height: 10px;
    }
  }
`;

export const ContentSizes = styled.div<iTextColorProps>`
  background-color: ${(props) => props.isAvaliable ? props.theme.colors.brand1.medium : props.theme.colors.brand4.pure};
  border:  ${(props) => props.isAvaliable ?  `1px solid ${props.theme.colors.brand1.medium}` : `1px solid ${props.theme.colors.brand1.pure}`};
  color: ${(props) => props.isAvaliable ? props.theme.colors.neutral2.dark : props.theme.colors.brand1.pure};
  width: 30px;
  height: 30px;
  border-radius: 80%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  > h6 {
    font-weight: normal;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    background-color:${(props) => props.isAvaliable ? '' : props.theme.colors.brand1.pure};
    opacity: 0.8;
    transform: rotate(140deg)
  }
`;

export const PricesContainer = styled.div<iTextColorProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;

  @media (min-width: 768px) {
    margin: 4px 0 0;
  }

  .p__old__value {
    text-decoration: line-through;
    font-size: 0.76rem;
    color: ${(props) =>
    props.priceColor || props.theme.colors.typography1.medium};
  
      @media (min-width: 768px) {
        font-size: 0.68rem;
      }
    }

  .p__discount {
    font-size: 0.8rem;
    color: #fe6f66;

    @media (min-width: 768px) {
      font-size: 0.78rem;
    }
  }
`;
